import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchIndicatorGroupList = createAsyncThunk(
  "fetchIndicatorGroupList",
  async ({page, limit}) => {

    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `vision/indicator/list?page=${page}&limit=${limit}`,
      config
    );

    return response.data.data;
  }
);

const indicatorGroupListSlice = createSlice({
  name: "indicatorGroupList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchIndicatorGroupList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchIndicatorGroupList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchIndicatorGroupList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default indicatorGroupListSlice.reducer;